import _ from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import { getGrowthBookFeatureFlag } from 'src/featureFlags';
import { PERFORMANCE_SNAPSHOT } from 'src/modules/constants';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import ChildComponent from 'src/workspace/childComponent';
import ActivityCalendar from './activityCalender';
import HelloCardComponent from './helloCard/index';
import { getFilterData, getHomeDashboardCards } from './selectors';
import HomePageFilter from './teamSelfFilter';
import { fetchHomeDashboardCards } from './thunk';
import styles from './index.module.scss';

function HomeDashboard() {
  const filterData = useAppSelector((state) => getFilterData(state));
  const helloCardData = useAppSelector(getHomeDashboardCards);
  const [isAtTop, setIsAtTop] = useState(true);
  const isPerformanceEnabled = getGrowthBookFeatureFlag(
    'enable-performance-dashboard',
  );

  const handleScroll = (e) => {
    const currentScrollY = e.currentTarget.scrollTop;

    // Only show the filter if we are at the absolute top (0)
    if (currentScrollY <= 0) {
      setIsAtTop(true);
    } else if (isAtTop) {
      // Only trigger a state change if we weren't already "not at top"
      setIsAtTop(false);
    }
  };

  const performanceSnapshotEnabled = useMemo(
    () =>
      isPerformanceEnabled &&
      _.find(helloCardData, (card) => card.type === 'performance_snapshot'),
    [helloCardData, isPerformanceEnabled],
  );

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (filterData?.filterData) {
      const params = {
        pages: true,
        filters: JSON.stringify(filterData?.filterData),
      };
      dispatch(fetchHomeDashboardCards({ params }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, JSON.stringify(filterData?.filterData || {})]);

  return (
    <div className={styles.dashboard}>
      <div
        className={`${styles.filterWrapper} ${
          isAtTop ? styles.filterWrapper__visible : styles.filterWrapper__hidden
        }`}
      >
        <HomePageFilter />
      </div>
      <div className={styles.dashboard__body} onScroll={handleScroll}>
        {performanceSnapshotEnabled && (
          <ChildComponent id={PERFORMANCE_SNAPSHOT} />
        )}
        <ActivityCalendar />
        <HelloCardComponent />
      </div>
    </div>
  );
}

export default HomeDashboard;
